export default __webpack_public_path__ + "static/media/Pachmarhi_valley_Madhya_Pradesh_INDIA.1eab77b0.jpg";